import React, { useEffect } from "react";

const ComprasOrdenesPage = () => {
  useEffect(() => {
    document.title = "Compras - Órdenes | Saas";
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title mb-3">Órdenes de compra</h4>
            <p className="text-muted mb-0">
              Sección en construcción. Acá podrás gestionar el ciclo de órdenes: creación, aprobación,
              seguimiento de proveedores y estados.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComprasOrdenesPage;
